import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { WatchlistsPage } from '@sorare/marketplace/src/components/watchlists/WatchlistsPage';

const Watchlists = () => {
  return <WatchlistsPage sport={Sport.BASEBALL} />;
};

export default Watchlists;
